module.exports = __webpack_public_path__ + "img/e-presc@2x.a310afb7.svg";